import { useCallback } from 'react';
import { useWindowDimensions } from 'react-native';

/**
 * Custom hook for handling responsive design in React Native applications.
 * @returns {Object} An object containing properties for responsive design.
 *   - isMobile: it is true if the device has a screen width < 768.
 *   - isTrue: it is true if the device has a screen width < 1280 & > 768.
 */
const useResponsiveScreen = () => {
  const { height, width } = useWindowDimensions();

  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;
  const isSmallDesktop = width >= 1024 && width < 1280;
  const isLargeDesktop = width >= 1280;
  const isDesktop = isSmallDesktop || isLargeDesktop;

  const percentageToPixelWidth = useCallback(
    (percentage: number) => {
      return (width * percentage) / 100;
    },
    [width],
  );

  const percentageToPixelHeight = useCallback(
    (percentage: number) => {
      return (height * percentage) / 100;
    },
    [height],
  );

  return {
    isMobile,
    isTablet,
    isSmallDesktop,
    isLargeDesktop,
    isDesktop,
    percentageToPixelWidth,
    percentageToPixelHeight,
  };
};

export default useResponsiveScreen;
